var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"},attrs:{"id":"app"}},[_vm._m(0),(
      _vm.path != '/sw' &&
      _vm.path != '/bd' &&
      _vm.path != '/baidu' &&
      _vm.path != '/bdAboutUs' &&
      _vm.path != '/bdproductInfo' &&
      _vm.path != '/bdpermit' &&
      _vm.path != '/bdsoftwareLis' &&
      _vm.path != '/bdprivacy'
    )?_c('router-view',{staticStyle:{"margin":"0"},style:({ minHeight: _vm.Height + 'px' })}):_c('router-view'),(
      _vm.path != '/sw' &&
      _vm.path != '/bd' &&
      _vm.path != '/baidu' &&
      _vm.path != '/bdAboutUs' &&
      _vm.path != '/bdproductInfo' &&
      _vm.path != '/bdpermit' &&
      _vm.path != '/bdsoftwareLis' &&
      _vm.path != '/bdprivacy' &&
      _vm.path != '/360m' &&
      _vm.path != '/msougou' &&
      _vm.path != '/wm' &&
      _vm.path != '/zdzm' &&
      _vm.path != '/uc'
    )?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","top":"0","opacity":"0"}},[_c('img',{attrs:{"src":"/static/img/achuanqi.png","alt":""}})])}]

export { render, staticRenderFns }